import { useTranslation } from "@opendash/i18n";
import { Form, Switch } from "antd";
import { Rule } from "antd/es/form";
import React from "react";

type Props = {
  index: number;
  styles: React.CSSProperties;
  rules: Rule[];
  label: string;
};

export default (props: Props) => {
  const t = useTranslation();

  return (
    <Form.Item
      label={props.label}
      name={[props.index, "value"]}
      rules={props.rules}
      style={props.styles}
      valuePropName="checked"
      initialValue={false}
    >
      <Switch
        checkedChildren={t(
          "openware:parse.form.operation.value.boolean.checked"
        )}
        unCheckedChildren={t(
          "openware:parse.form.operation.value.boolean.unchecked"
        )}
      />
    </Form.Item>
  );
};
